import { Dispatch, lazy, SetStateAction } from "react";
import { DateRange } from "react-day-picker";
import { useTranslation } from "react-i18next";

import { DateRangeChanger } from "./DateRangeChanger";
import { PdfData } from "./ReportsTable";

const DownloadReport = lazy(() => import("./DownloadReport/DownloadReport"));

interface TableHeaderProps {
  dateRange?: DateRange;
  onDateRangeChange: (dateRange: DateRange) => void;
  setSelectedWageTypes: Dispatch<SetStateAction<number[]>>;
  pdfData: PdfData;
}

export function TableHeader({
  dateRange,
  onDateRangeChange,
  setSelectedWageTypes,
  pdfData,
}: TableHeaderProps) {
  const { t } = useTranslation();
  const handleWageTypeChange = (wageType: number, checked: boolean) => {
    setSelectedWageTypes((prev) => {
      if (checked) {
        return [...prev, wageType];
      } else {
        return prev.filter((type) => type !== wageType);
      }
    });
  };

  return (
    <div className="px-7.5 py-5 flex flex-row justify-between">
      <div className="flex items-center">
        <DateRangeChanger
          dateRange={dateRange}
          onDateRangeChange={onDateRangeChange}
        />
      </div>
      <div className="flex flex-row items-center gap-4">
        <label className="switch switch-sm">
          <input
            className=""
            name="check"
            type="checkbox"
            value={3}
            onChange={(e) => handleWageTypeChange(3, e.target.checked)}
            defaultChecked
          />
          <span className="switch-label">
            {t("shift.Monthly Salary Personnel")}
          </span>
        </label>
        <label className="switch switch-sm">
          <input
            className=""
            name="check"
            type="checkbox"
            value={1}
            onChange={(e) => handleWageTypeChange(1, e.target.checked)}
            defaultChecked
          />
          <span className="switch-label">
            {t("shift.Hourly Wage Personnel")}
          </span>
        </label>
      </div>
      <DownloadReport pdfData={pdfData} />
    </div>
  );
}
